const stickyHeader = "_61s1l82s02";
const button = "_61b6qxliv";

export { button, stickyHeader };
import "./sticky-login.style.linaria.module.css";
//# sourceMappingURL=sticky-login.style.js.map
